var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 312.23849,
    style: {
      fillRule: "evenodd"
    },
    viewBox: "0 0 1004.6054 288.29715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.97966,175.26389)",
    style: {
      fill: "#ed1d24",
      fillRule: "nonzero",
      stroke: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(13.834487,0,0,-13.834487,-131.35425,-28.987438)",
    d: "m 0,0 c -0.951,3.775 -4.367,6.57 -8.438,6.57 -4.806,0 -8.702,-3.896 -8.702,-8.702 0,-4.806 3.896,-8.702 8.702,-8.702 4.071,0 7.487,2.795 8.438,6.57 l -3.672,0 c -0.815,-1.82 -2.642,-3.089 -4.766,-3.089 -2.883,0 -5.221,2.338 -5.221,5.221 0,2.884 2.338,5.221 5.221,5.221 2.124,0 3.95,-1.269 4.766,-3.089 L 0,0 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(13.834487,0,0,-13.834487,120.25358,0.50907229)",
    d: "m 0,0 c 0,4.806 -3.896,8.702 -8.702,8.702 -4.806,0 -8.702,-3.896 -8.702,-8.702 0,-4.806 3.896,-8.702 8.702,-8.702 C -3.896,-8.702 0,-4.806 0,0 m -3.481,0 c 0,-2.883 -2.337,-5.221 -5.221,-5.221 -2.884,0 -5.221,2.338 -5.221,5.221 0,2.884 2.337,5.221 5.221,5.221 2.884,0 5.221,-2.337 5.221,-5.221"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(13.834487,0,0,-13.834487,135.87132,-191.76125)",
    d: "m 0,0 0,-22.174 3.814,0 0,22.175 L 0,0 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(13.834487,0,0,-13.834487,432.51732,11.359459)",
    d: "m 0,0 c 0.025,0.284 0.037,0.574 0.037,0.87 0.01,6.443 -4.885,8.616 -8.267,8.616 l -0.002,0 c -3.382,0 -8.274,-2.173 -8.264,-8.616 -0.01,-5.343 3.87,-8.789 8.264,-8.787 l 0.002,0 c 3.552,-0.001 6.766,2.249 7.864,5.931 l -3.743,0 C -4.958,-3.638 -6.528,-4.611 -8.23,-4.611 l -0.002,0 c -2.301,-0.001 -4.362,1.779 -4.728,4.614 l 9.458,0 L -3.502,0 0,0 z m -8.232,6.354 0,0 0.002,0 c 1.587,0 3.748,-0.9 4.509,-3.404 l -9.018,0 c 0.759,2.504 2.92,3.404 4.507,3.404"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(13.834487,0,0,-13.834487,537.67328,120.3019)",
    d: "m 0,0 c -4.399,0 -6.921,2.119 -6.921,5.814 l 0,0.074 3.443,0 0.003,-0.072 c 0.15,-1.968 1.388,-2.925 3.782,-2.925 1.992,0 3.232,0.813 3.232,2.123 0,1.111 -0.842,1.524 -2.5,1.939 l -2.431,0.615 c -1.81,0.444 -3.019,0.968 -3.802,1.648 -0.865,0.748 -1.265,1.71 -1.265,3.027 0,1.508 0.58,2.78 1.68,3.676 1.122,0.915 2.743,1.399 4.686,1.399 2.014,0 3.703,-0.5 4.887,-1.445 1.171,-0.934 1.788,-2.253 1.788,-3.815 l 0,-0.031 -3.411,0 -0.003,0.029 c -0.091,1.591 -1.262,2.432 -3.384,2.432 -1.668,0 -2.707,-0.66 -2.707,-1.723 0,-1.181 1.027,-1.653 2.685,-2.031 l 2.06,-0.461 C 5.209,9.487 7.044,8.484 7.044,5.445 7.044,3.776 6.41,2.397 5.209,1.456 3.996,0.504 2.193,0 0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColesLogo);
export default __webpack_public_path__ + "static/media/coles-logo.9bd396a54290d194d2b64ffad3ed3933.svg";
export { ForwardRef as ReactComponent };